/// <amd-module name="Checks/TaskChecks/Components/ArtifactPolicyCheckWrapperComponent" />
import * as React from "react";

import { CheckAction, ChecksTableCellRenderer, ICheckWrapperComponentProps } from "Checks/Client/Contracts/Contracts";
import { CheckConfiguration, TaskCheckConfiguration } from "Checks/Client/Contracts/PipelinesChecks";
import { ArtifactPolicyCheckComponent, IArtifactPolicyCheckProps } from "Checks/TaskChecks/Components/ArtifactPolicyCheckComponent";

import { equals } from "VSS/Core/Util/String";
import { Components, VssComponent } from "VSS/Platform/Layout";

import { Tooltip } from "VSSUI/TooltipEx";

const artifactPolicyCheckTypeId: string = "fe1de3ee-a436-41b4-bb20-f6eb4cb879a7";

export class ArtifactPolicyCheckWrapperComponent extends VssComponent<ICheckWrapperComponentProps> {

    public render(): JSX.Element {
        if (this.props.checkConfigObject) {
            this._artifactPolicyCheckConfig = this.props.checkConfigObject as TaskCheckConfiguration;
            if (!equals(this._artifactPolicyCheckConfig.type.id, artifactPolicyCheckTypeId, true)) {
                return <div />;
            }
        }

        if (this.props.checkTableCellToRender !== undefined && this.props.checkConfigObject) {
            return this.renderCheckTableCell(this.props.checkTableCellToRender);
        }
        else if (this.props.checkAction === CheckAction.Create) {
            return (
                <ArtifactPolicyCheckComponent
                    {
                        ...this._getArtifactPolicyCheckProps()
                    }/>
            );
        }
        else if (this.props.checkAction === CheckAction.Edit) {
            return (
                <ArtifactPolicyCheckComponent
                    {
                        ...this._getArtifactPolicyCheckProps()
                    }/>
            );
        }
        return <div />;
    }

    private renderCheckTableCell(checkTableCell: ChecksTableCellRenderer): JSX.Element {
        switch (checkTableCell) {
            case ChecksTableCellRenderer.DisplayName:
                return this._renderDisplayNameCell();
            case ChecksTableCellRenderer.Details:
                return <span />;
            default:
                return <div />;
        }
    }

    private _renderDisplayNameCell(): JSX.Element {
        let displayName = this._artifactPolicyCheckConfig.settings.displayName;
        return (
            <Tooltip text={displayName}>
                <div className="body-m primary-text">
                    {displayName}
                </div>
            </Tooltip>
        );
    }

    private _getArtifactPolicyCheckProps = (): IArtifactPolicyCheckProps => {
        let initialCheckConfiguration = this._artifactPolicyCheckConfig ? this._artifactPolicyCheckConfig.settings : undefined;

        return ({
            initialCheckConfiguration: initialCheckConfiguration,
            resource: this.props.resource,
            disableCreateButton: this.props.disableCreateButton ? this.props.disableCreateButton : (val: boolean) => { },
            updateCheckDataAndEnableSave: this.props.updateCheckDataAndEnableSave ? this.props.updateCheckDataAndEnableSave : (val: CheckConfiguration) => { },
            updateTelemetryData: this.props.updateTelemetryData ? this.props.updateTelemetryData : (val: { [key: string ]: string }) => {}
        });
    }

    private _artifactPolicyCheckConfig: TaskCheckConfiguration;
}


Components.add("opa-check-view", ArtifactPolicyCheckWrapperComponent);
